import { render, staticRenderFns } from "./folderCard.vue?vue&type=template&id=4d6177bf&scoped=true&"
import script from "./folderCard.vue?vue&type=script&lang=js&"
export * from "./folderCard.vue?vue&type=script&lang=js&"
import style0 from "./folderCard.vue?vue&type=style&index=0&id=4d6177bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6177bf",
  null
  
)

export default component.exports